module.exports = __webpack_public_path__ + "static/media/thoriacImage1@3x.a74f70a9.png";